import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import {
  determineIfDayIsNonWorking,
  getFinalDocumentAdmissionDate,
  saveFinalDocumentAdmissionDate,
} from 'app/edozvola/cases/final-document-admission/service/final-document-admission.service';
import { messages } from 'app/config/constants';
import success = toast.success;
import error = toast.error;
import moment from 'moment';

export const saveFinalDocumentAdmissionQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (finalDocumentAdmission: any) => {
      return saveFinalDocumentAdmissionDate(idCase, finalDocumentAdmission);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['final-document-admission', { idCase: idCase }] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const getFinalDocumentAdmissionQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['final-document-admission', { idCase: idCase }],
    queryFn: ({ signal }) => getFinalDocumentAdmissionDate(idCase),
  });
};

export const determineIfDayIsNonWorkingMutation = (updateAppealDateExpiration: any) => {
  return useMutation({
    mutationFn: (dayToCheck: Date) => {
      return determineIfDayIsNonWorking(dayToCheck);
    },
    onSuccess: (data, variables, context) => {
      if (data.weekendDay || data.publicHoliday) {
        updateAppealDateExpiration(moment(variables).startOf('day').utc(true).add(data.numberOfDaysToNextWorkingDay, 'day').toDate())
      } else {
        updateAppealDateExpiration(variables)
      }
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
}

